import { VisualizationMarkdown } from '../components/VisualizationMarkdown';
import logo from '../logo.svg';

export function MarkdownPage() {
    const markdown = `# Markdown

This project includes [React Markdown](https://github.com/remarkjs/react-markdown), thus you can use the tag \`<ReactMarkdown># Hello</ReactMarkdown\` to display markdown.

Furthermore the project has a default configuration for \`ReactMarkdown\`, namely the \`VisualizationMarkdown\`. You can find, alter, and extend the default Markdown in \`src/components/ViszalizationMarkdown.tsx\`. In the following we are going to describe \`VisualizationStack\` features.

## Sanitation
Input gets sanitized: dangerous tags like \`<script>\` get removed, meaning it's okay to render user added content via markdown.
<script>alert('danger! This should be escaped to prevent XSS.');</script>

## Github falvored markdown
We use github flavored markdown so we can do:
- Lists
- [ ] todos and 
- [x] dones
- *emphasis* and **strong importance**
- and ~strikethrough~
- Urls https://google.ch or like [this](https://google.ch)
- Inline \`code\`
- Images via \`![Text](ImageUrl)\` or via \`<img src='ImageUrl' width='250px' />\`

<img src='${logo}' width='250px' />

A table:
| First name | Last Name         |
| ---------- | ----------------- |
| Otto       | Normalverbraucher |
| Jane       | Doe               |

## Formulas

Some formulas using the rehype-katex plugin:
<div class="math math-display">
    L = \\frac{1}{2} \\rho v^2 S C_L
</div>
Where some stuff like <span class="math math-inline">C_L</span> can also be inlined
`
    return <VisualizationMarkdown>{markdown}</VisualizationMarkdown>
}